<template>
  <div>
    <loading-spinner v-if="!activityStream.activities && loading !== 0" />
    <activity-stream
      v-else
      :activity-stream="activityStream"
      @loadMore="loadMore"
    />
  </div>
</template>

<script>
import ActivityStream from '@/components/User/Activity/ActivityStream.vue';
import { ACTIVITY_STREAM_QUERY } from '@/graphql/queries/activity-stream-queries';

export default {
  name: 'PaginatedActivityStream',
  components: {
    ActivityStream,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activityStream: {
        activities: [],
        pageInfo: {},
      },
      userId: this.user.id,
      first: 5,
      loading: 0,
    };
  },
  methods: {
    loadMore(endId) {
      this.$apollo.queries.activityStream.fetchMore({
        variables: {
          first: this.first,
          after: endId,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newActivities = fetchMoreResult.activityStream.activities
            .filter((newActivity) => !previousResult.activityStream.activities
              .some((oldActivity) => oldActivity.id === newActivity.id));
          return {
            activityStream: {
              // eslint-disable-next-line no-underscore-dangle
              __typename: fetchMoreResult.activityStream.__typename,
              activities: [
                ...previousResult.activityStream.activities,
                ...newActivities,
              ],
              pageInfo: fetchMoreResult.activityStream.pageInfo,
            },
          };
        },
      });
    },
  },
  apollo: {
    activityStream: {
      query: ACTIVITY_STREAM_QUERY,
      variables() {
        return {
          first: this.first,
          userId: this.userId,
        };
      },
    },
  },
};
</script>
